import * as styles from "./QuickLinksItem.module.scss";

import cx from "classnames";
import { navigate } from "gatsby";
import React from "react";
import { pushToDataLayer } from "../../../utils/google";
import ProcessedImage from "../ProcessedImage/ProcessedImage";

export interface QuickLinksItemProps {
	title: string;
	imgSrc: string;
	imgAlt: string;
	url: string;
	height?: number;
	priority?: number;
	isHomePage?: boolean;
	isLastItem?: boolean;
}

export const QuickLinksItem: React.FC<QuickLinksItemProps> = ({
	title,
	imgSrc,
	imgAlt,
	url,
	isHomePage,
	isLastItem,
}) => {
	return (
		<button
			className={cx(styles.component, {
				[styles.component]: !isHomePage,
				[styles.componenthome]: isHomePage,
				[styles.lastItem]: isLastItem,
			})}
			type="button"
			tabIndex={0}
			onClick={(e) => {
				e.preventDefault();
				pushToDataLayer({
					event: "button_navigation",
					button_clicked: title,
					button_url: url,
					button_location: window.location.href,
				});
				navigate(url);
			}}
			onKeyDown={(e) => {
				if (e.key === "Enter") navigate(url);
			}}
		>
			<span
				className={isHomePage ? styles.iconwrapperhome : styles.iconwrapper}
			>
				<ProcessedImage
					src={imgSrc}
					dimensions="80x80"
					width={80}
					height={80}
					alt={imgAlt}
				/>
			</span>
			<h2
				className={
					isHomePage ? styles.quicklinkstitlehome : styles.quicklinkstitle
				}
			>
				{title}
			</h2>
		</button>
	);
};

export default QuickLinksItem;
